module.exports = __webpack_public_path__ + "static/media/close.e6d902b3.svg";